import { makeStyles } from 'tss-react/mui';

export const useWeeklyGrossPayStyles = makeStyles()((theme) => ({
  customContentClass: {
    padding: 0,
    maxHeight: '425px',
    overflowY: 'auto',
    width: '100%',
  },
  weeklyGrossPayContainer: {
    width: '100%', 
    minWidth: 0,
    background: `${theme.palette.system.lightGrey2} 0% 0% no-repeat padding-box`,
  },
  tableContainer: {
    width: '100%',                   
    minWidth: 0,
  },
  headerBox: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    fontWeight: 700,
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    fontSize: 14,          
    letterSpacing: 0.2,   
  },
  tableCardContainer: {
    borderRadius: '6px',
    border: `1px solid ${theme.palette.divider}`,
    background: theme.palette.framework.system.white,
    marginBottom:'5px'
  }
}));
